import Joi from "joi";

export const createExitFormalitySchema = Joi.object({
    exit_date: Joi.date().required().messages({
        "date.base": "Exit Date is required.",
        "any.required": "Exit Date is required.",
    }),
    settlement_date: Joi.date().required().messages({
        "date.base": "Exit Date is required.",
        "any.required": "Settlement Date is required.",
        "any.invalid": "Settlement date must be after the exit date.",
    })
    // .custom((value, helpers) => {
    //     const { exit_date, settlement_date } = helpers?.prefs?.context || {};
    //     if (new Date(exit_date) > new Date(settlement_date)) {
    //         return helpers.error("any.invalid", {
    //             message: "Settlement date must be after the exit date.",
    //         })
    //     }
    //     return value
    // })
    ,
    reason_for_exit: Joi.string().max(255).required().messages({
        "string.empty": "Exit Reason is required.",
        "any.required": "Exit Reason is required.",
        "any.invalid":"Exit Reason is required.",
        "string.max": "Exit Reason cannot exceed 255 characters.",

    }),
})